/**
 * @generated SignedSource<<74ca95244d4ce8037d7e31b8bc3c520d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AgendaGeneratorPreviewApplyAgendaMutation$variables = {
  agenda: any;
  noteId: string;
  purpose?: string | null;
  setAsDefaultTemplate?: boolean | null;
};
export type AgendaGeneratorPreviewApplyAgendaMutation$data = {
  readonly applyGeneratedAgenda: {
    readonly ok: boolean | null;
  } | null;
};
export type AgendaGeneratorPreviewApplyAgendaMutation = {
  response: AgendaGeneratorPreviewApplyAgendaMutation$data;
  variables: AgendaGeneratorPreviewApplyAgendaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agenda"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "purpose"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "setAsDefaultTemplate"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "agenda",
        "variableName": "agenda"
      },
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      },
      {
        "kind": "Variable",
        "name": "purpose",
        "variableName": "purpose"
      },
      {
        "kind": "Variable",
        "name": "setAsDefaultTemplate",
        "variableName": "setAsDefaultTemplate"
      }
    ],
    "concreteType": "ApplyGeneratedAgenda",
    "kind": "LinkedField",
    "name": "applyGeneratedAgenda",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgendaGeneratorPreviewApplyAgendaMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgendaGeneratorPreviewApplyAgendaMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "4bd3b6ab2ebcc47ed02b0cf20054e480",
    "id": null,
    "metadata": {},
    "name": "AgendaGeneratorPreviewApplyAgendaMutation",
    "operationKind": "mutation",
    "text": "mutation AgendaGeneratorPreviewApplyAgendaMutation(\n  $noteId: ID!\n  $agenda: JSON!\n  $setAsDefaultTemplate: Boolean\n  $purpose: String\n) {\n  applyGeneratedAgenda(noteId: $noteId, agenda: $agenda, setAsDefaultTemplate: $setAsDefaultTemplate, purpose: $purpose) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "6eb0a3261f87129368f6aa1eb1cfe7ab";

export default node;
